import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef, GridValidRowModel, GridValueGetterParams } from '@mui/x-data-grid';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';
import { transformDateStringFrance } from '@/utilities/datetime';
import { Client } from '@/types/client';
import { GridAction } from '@/components/molecules/section/Grid';
import { getExtraPayoutUrl } from '@/utilities/url';

const ExtraPayout: React.FC<{ client: Client; isBuyer: boolean }> = ({ client, isBuyer }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(true);

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('client.extra_payouts.create').toUpperCase(),
      onClick: () => {
        window.open(getExtraPayoutUrl({ action: 'create' }), '_blank');
      },
    },
  ];

  const columns: GridColDef[] = [
    { field: 'amount', headerName: t('client.extra_payouts.amount') },
    { field: 'currency', headerName: t('client.extra_payouts.currency') },
    { field: 'clientPaymentId', headerName: t('client.extra_payouts.client_payment_id') },
    { field: 'payoutStatus', headerName: t('client.extra_payouts.payout_status') },
    {
      field: 'paymentDate',
      headerName: t('client.extra_payouts.payment_date'),
      valueGetter: (params: GridValueGetterParams) => (params.value ? transformDateStringFrance(params.value) : '-'),
    },
  ];

  const rows: GridValidRowModel[] = client?.extraPayouts?.map((_) => ({ ..._, id: _.clientPaymentId })) || [];

  return (
    <Container
      title={t('client.extra_payouts.title')}
      handler={{ open, setOpen }}
      actions={isBuyer ? [] : actions}
      testId="extra_payout"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={false}
        table={{
          kind: 'Table',
        }}
      />
    </Container>
  );
};

export default ExtraPayout;
